import React from 'react'

const ConfirmationPageText = () => {
  return (
    <div className="fontWeightBold fontSizeXs lh16">
      Vos informations et documents ont bien été réceptionnés et sont en cours
      de traitement par nos équipes.
      <p className="textPrimary">
        Il est possible que nous revenions vers vous après analyse des
        informations transmises.
      </p>
      <p>Vous pouvez désormais quitter cette page.</p>
    </div>
  )
}

export default ConfirmationPageText
